import { apiSlice } from '../../api-slice';

export const resource = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getResource: builder.query({
      query: () => `roles/resources`,
      keepUnusedDataFor: 600,
    }),
  }),
});

export const { useGetResourceQuery } = resource;
